import React, { useEffect, useState } from 'react';
import { IoIosAdd } from 'react-icons/io';
import { Tooltip, Button } from '@mui/material';
import { CiSquarePlus, CiSquareRemove } from 'react-icons/ci';
import axios from 'axios';
import Key from '../clientVariables.json';

const StickyNote = ({ note, index, updateNote, deleteNote }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [text, setText] = useState(note);
  const handleEdit = () => {
    if (text.trim() !== '') {
      updateNote(index, text);
      setIsEditing(false);
    }
  };

  return (
    <div className="col-12" style={{ display: 'flex', width: '100%' }}>
      <div className="sticky-note card" style={{ color: '#000', width: '100%', marginBottom: '15px' }}>
        {isEditing ? (
          <textarea
            value={text}
            onChange={(e) => setText(e.target.value)}
            onBlur={handleEdit}
            style={{ fontSize: '12px' ,width:"100%"}}
            //   autoFocus
          />
        ) : (
          <Button
            style={{ display: 'flex', width: '100%', color: '#000', fontSize: '12px', fontWeight: '500' }}
            onClick={() => setIsEditing(true)}
          >
            {note}
          </Button>
        )}
      </div>
      <div>
        <Button onClick={() => deleteNote(index)} style={{ color: '#000' }}>
          <CiSquareRemove style={{ fontSize: '25px' }} />
        </Button>
      </div>
    </div>
  );
};

const Stickynotes = ({ contactDetails }) => {
  const [notes, setNotes] = useState([]);
  const [addNoteShow, setAddNoteShow] = useState(false);
  const [text, setText] = useState("");


  useEffect(() => {
    getNotes();
  }, []);

  const getNotes = () => {
    fetch(`${Key.domain}/company/get_contact_notes`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        user_id: sessionStorage.getItem('id'),
        contact_id: contactDetails?.ID,
      }),
    }).then((response) => {
      response.json().then((resdata) => {
        console.log(resdata);

        if (resdata?.success === 1) {
          const notes = resdata?.data;
          console.log(notes);
          setNotes(notes);
          setAddNoteShow(false);
          setText("")
        }
      });
    });
  };

  const addNote = () => {
    fetch(`${Key.domain}/company/add_contact_note`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        user_id: sessionStorage.getItem('id'),
        contact_id: contactDetails?.ID,
        note: text,
      }),
    }).then((response) => {
      response.json().then((resdata) => {

        if (resdata?.success === 1) {
          getNotes();
        } else {
          getNotes();
        }
      });
    });
  };

  const updateNote = (index, updatedNote) => {

    fetch(`${Key.domain}/company/update_contact_note`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        user_id: sessionStorage.getItem('id'),
        contact_id: contactDetails?.ID,
        note: updatedNote,
        note_id: index,
      }),
    }).then((response) => {
      response.json().then((resdata) => {

        if (resdata?.success === 1) {
          getNotes();
        } else {
          getNotes();
        }
      });
    });
  };

  const deleteNote = (index) => {
    fetch(`${Key.domain}/company/delete_contact_note`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        user_id: sessionStorage.getItem('id'),
        contact_id: contactDetails?.ID,
        note_id: index,
      }),
    }).then((response) => {
      response.json().then((resdata) => {

        if (resdata?.success === 1) {
          getNotes();
        } else {
          getNotes();
        }
      });
    });
  };

  return (
    <div>
      <Tooltip title="Add Notes" arrow>
        <Button onClick={()=> setAddNoteShow(true)} style={{ float: 'right', marginTop: '-31px', color: '#000' }}>
          <CiSquarePlus style={{ fontSize: '25px' }} />
        </Button>
      </Tooltip>
      {addNoteShow ? (
        <textarea
          value={text}
          onChange={(e) => setText(e.target.value)}
          onBlur={addNote}
          style={{ fontSize: '12px',width:"100%" }}
          //   autoFocus
        />
      ) : null}
      {notes?.length > 0 &&
        notes?.map((note, index) => (
          <StickyNote
            key={index}
            note={note?.message}
            index={note?.id}
            updateNote={updateNote}
            deleteNote={deleteNote}
            style={{ width: '100%', color: '#000', marginBottom: '5px' }}
          />
        ))}
    </div>
  );
};

export default Stickynotes;
